<template>
  <div :id="id" :items="items" :dimensions="dimensions" :style="`height:${height};`"></div>
</template>

<script>
  import * as echarts from 'echarts'

  export default {
    name: 'Echart07M05',
    props: ['id', 'height', 'datas', 'items', 'dimensions'],
    data() {
      return {

      }
    },
    watch: {
      datas: {
        deep: true,
        handler: function(newV, oldV) {
          if(!newV) return
          this.draw()
        }
      }
    },
    mounted() {
      this.draw()
    },
    methods: {
      draw() {
        if (document.getElementById(this.id) == null) {
          return
        }
        echarts.dispose(document.getElementById(this.id))
        const myChart = echarts.init(document.getElementById(this.id))
        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            itemWidth: 16,
            itemHeight : 8,
            data: this.items,
            textStyle: {
              color: 'rgba(255, 255, 255, .8)'
            },
            padding: [30, 15, 0, 15]
          },
          dataset: {
            dimensions: this.dimensions,
            source: this.datas,
          },
          grid: {
            left: '6%',
            right: '14%',
            bottom: '3%',
            top: 90,
            containLabel: true
          },
          yAxis: {
            type: 'category',
            axisLabel: {
            	color: '#2dfcff',
            	fontSize: 12,
              interval: 0, 
              rotate: 0 
            }
          },
          xAxis: [
            {
              type: 'value',
              name: 'w',
              nameTextStyle: {
                fontSize: 10
              },
              splitLine: {
                lineStyle: {
                  color:'rgba(255, 255, 255, .0)',
                  type: 'dashed'
                }
              },
              axisLabel: {
              	color: 'rgba(255, 255, 255, .6)',
              	fontSize: 10
              },
            },
            {
              type: 'value',
              name: '%',
              nameTextStyle: {
                fontSize: 10
              },
              splitLine: {
                lineStyle: {
                  color:'rgba(255, 255, 255, .1)',
                  type: 'dashed'
                }
              },
              axisLabel: {
              	color: 'rgba(255, 255, 255, .6)',
              	fontSize: 10
              },
            }
          ],
          series: [{
              name: this.items[0],
              type: 'bar',
              barWidth: 8,
              itemStyle: {
                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  { offset: 0, color: 'rgba(255, 255, 255, .2)' },
                  { offset: 1, color: 'rgba(255, 255, 255, .4)' }
                ])
              },
              label:{
                show: true,
                position: 'right',
                color: 'rgba(255, 255, 255, .8)',
                fontSize: 10,
                offset: [0, 1],
                rotate: 0 ,
                formatter: '{@'+ this.dimensions[1] +'}',
              }
            },
            {
              name: this.items[1],
              type: 'line',
              xAxisIndex: 1,
              itemStyle: {
                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  { offset: 0, color: '#ffda2d' },
                  { offset: 1, color: '#ff6f06' }
                ])
              },
              label:{
                show: true,
                position: 'right',
                color: 'rgba(255, 255, 255, .8)',
                fontSize: 10,
                // offset: [14, 6],
                rotate: 0,
                formatter: '{@'+ this.dimensions[2] +'}%',
              }
            },
            {
              name: this.items[2],
              type: 'bar',
              barWidth: 8,
              itemStyle: {
                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  { offset: 0, color: '#06ff98' },
                  { offset: 1, color: '#2dfcff' }
                ])
              },
              label:{
                show: true,
                position: 'right',
                color: 'rgba(255, 255, 255, .8)',
                fontSize: 10,
                offset: [0, 1],
                rotate: 0 
              }
            },
            {
              name: this.items[3],
              type: 'bar',
              barWidth: 8,
              itemStyle: {
                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  { offset: 0, color: '#ffda2d' },
                  { offset: 1, color: '#ff6f06' }
                ])
              },
              label:{
                show: true,
                position: 'right',
                color: 'rgba(255, 255, 255, .8)',
                fontSize: 10,
                offset: [0, 1],
                rotate: 0 
              }
            },
            {
              name: this.items[4],
              type: 'bar',
              barWidth: 8,
              itemStyle: {
                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  { offset: 0, color: '#ff9dc4' },
                  { offset: 1, color: '#be2dfa' }
                ])
              },
              label:{
                show: true,
                position: 'right',
                color: 'rgba(255, 255, 255, .8)',
                fontSize: 10,
                offset: [0, 1],
                rotate: 0 
              }
            },
            {
              name: this.items[5],
              type: 'bar',
              barWidth: 8,
              itemStyle: {
                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  { offset: 0, color: '#e7e7e7' },
                  { offset: 1, color: '#ffffff' }
                ])
              },
              label:{
                show: true,
                position: 'right',
                color: 'rgba(255, 255, 255, .8)',
                fontSize: 10,
                offset: [0, 1],
                rotate: 0 
              }
            },
          ]
        }
        myChart.setOption(option, true)
      }
    }
  }
</script>

<style>
</style>
